import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import axios from "axios";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import Sidebar from "./components/sidebar/Sidebar";
import Navbar from "./components/navbar/Navbar";
import Login from "./components/login/Login";
import "./App.css";
import Footer from "./components/footer/Footer";
import GlobalToast from "./components/common/GlobalToast";
import SearchHighlightManager from "./components/common/SearchHighlightManager";
const Dashboard = React.lazy(() => import("./components/pages/Dashboard"));
const User = React.lazy(() => import("./components/pages/User"));
const HrManagement = React.lazy(() => import("./components/pages/HrManagement"));
const Roles = React.lazy(() => import("./components/pages/Roles"));
const AddRoles = React.lazy(() => import("./components/pages/AddRoles"));
const Doctors = React.lazy(() => import("./components/pages/Doctors"));
const FeesManagement = React.lazy(() => import("./components/pages/FeesManagement"));
const Patients = React.lazy(() => import("./components/pages/Patients"));
const AddPatients = React.lazy(() => import("./components/pages/AddPatients"));
const Expenses = React.lazy(() => import("./components/pages/Expenses"));
const HospitalMaintainence = React.lazy(() => import("./components/pages/HospitalMaintainence"));
const HospitalPurchase = React.lazy(() => import("./components/pages/HospitalPurchase"));
const AddHospitalPurchase = React.lazy(() => import("./components/pages/AddHospitalPurchase"));
const UpdateHospitalPurchase = React.lazy(() => import("./components/pages/UpdateHospitalPurchase"));
const MedicineMaster = React.lazy(() => import("./components/pages/Pharmacy/MedicineMaster"));
const PurchasePharmacy = React.lazy(() => import("./components/pages/Pharmacy/PurchasePharmacy"));
const SalePharmacy = React.lazy(() => import("./components/pages/Pharmacy/SalePharmacy"));
const StockPharmacy = React.lazy(() => import("./components/pages/Pharmacy/StockPharmacy"));
const SupplierPharmacy = React.lazy(() => import("./components/pages/Pharmacy/SupplierPharmacy"));
const ReportPharmacy = React.lazy(() => import("./components/pages/Pharmacy/ReportPharmacy"));
const AddPurchasePharmacy = React.lazy(() => import("./components/pages/Pharmacy/AddPurchasePharmacy"));
const AddSalePharmacy = React.lazy(() => import("./components/pages/Pharmacy/AddSalePharmacy"));
const Reports = React.lazy(() => import("./components/pages/Reports"));
const Hospitalbill = React.lazy(() => import("./components/pages/Hospitalbill"));
const SalesBill = React.lazy(() => import("./components/pages/Pharmacy/Bills/SalesBill"));
const Opbill = React.lazy(() => import("./components/pages/Opbill"));
const DischargeSummary = React.lazy(() => import("./components/pages/DischargeSummary"));
const Staff = React.lazy(() => import("./components/pages/HR_Management/Staff"));
const AddStaff = React.lazy(() => import("./components/pages/HR_Management/AddStaff"));
const UpdateStaff = React.lazy(() => import("./components/pages/HR_Management/UpdateStaff"));
const Holiday = React.lazy(() => import("./components/pages/HR_Management/Holiday"));
const Leave = React.lazy(() => import("./components/pages/HR_Management/Leave"));
const Attendance = React.lazy(() => import("./components/pages/HR_Management/Attendance"));
const Department = React.lazy(() => import("./components/pages/HR_Management/Department"));
const SalaryDetails = React.lazy(() => import("./components/pages/HR_Management/SalaryDetails"));
const AddSalaryDetails = React.lazy(() => import("./components/pages/HR_Management/AddSalaryDetails"));
const UpdateSalaryDetails = React.lazy(() => import("./components/pages/HR_Management/UpdateSalaryDetails"));
const AttendanceCalendar = React.lazy(() => import("./components/pages/HR_Management/AttendanceCalendar"));
const Shift = React.lazy(() => import("./components/pages/HR_Management/Shift"));
const Appointment = React.lazy(() => import("./components/pages/Appointment"));
const Doctorfees = React.lazy(() => import("./components/pages/Fees_Management/Doctorfees"));
const Treatment = React.lazy(() => import("./components/pages/Fees_Management/Treatment"));
const DynamicBilling = React.lazy(() => import("./components/pages/Fees_Management/DynamicBilling"));
const BillCustomization = React.lazy(() => import("./components/pages/Fees_Management/BillCustomization"));
const DiscountOffer = React.lazy(() => import("./components/pages/Fees_Management/DiscountOffer"));
const UpdatePatients = React.lazy(() => import("./components/pages/UpdatePatients"));
const ViewPatient = React.lazy(() => import("./components/pages/ViewPatients"));
const PrescriptionData = React.lazy(() => import("./components/pages/Prescriptiondata"));
const PurchaseOrder = React.lazy(() => import("./components/pages/Pharmacy/PurchaseOrder"));
const AddPurchaseOrder = React.lazy(() => import("./components/pages/Pharmacy/AddPurchaseOrder"));
// IN BILLING TEMPORARILY DISABLED
// import InBilling from "./components/pages/InBilling";
const OutBilling = React.lazy(() => import("./components/pages/OutBilling"));
// import AddInBilling from "./components/pages/AddInBilling";
// import UpdateInBilling from "./components/pages/UpdateInBilling";
const AddOutBilling = React.lazy(() => import("./components/pages/AddOutBilling"));
const UpdateOutBilling = React.lazy(() => import("./components/pages/UpdateOutBilling"));
const SalePreviewBill = React.lazy(() => import("./components/pages/Pharmacy/Bills/SalePreviewBill"));
const UpdateSalePharmacy = React.lazy(() => import("./components/pages/Pharmacy/UpdateSalePharmacy"));
const Prescription = React.lazy(() => import("./components/pages/Pharmacy/Prescription"));
const PatientsHistory = React.lazy(() => import("./components/pages/PatientsHistory"));
// import OpInBilling from "./components/pages/OpInBilling";
const UpdatePurchasePharmacy = React.lazy(() => import("./components/pages/Pharmacy/UpdatePurchasePharmacy"));
const UpdatePurchaseOrder = React.lazy(() => import("./components/pages/Pharmacy/UpdatePurchaseOrder"));
const LabManagement = React.lazy(() => import("./components/pages/LabManagement"));
const AddLabManagement = React.lazy(() => import("./components/pages/AddLabManagement"));
const UpdateLabManagement = React.lazy(() => import("./components/pages/UpdateLabManagement"));
const Notification = React.lazy(() => import("./components/pages/Notification"));
const Prescriptionbill = React.lazy(() => import("./components/pages/Pharmacy/Bills/Prescriptionbill"));
// const Yoga_Patients = React.lazy(() => import("./components/pages/Yoga_Patients"));
// const Homeopathy_Patients = React.lazy(() => import("./components/pages/Homeopathy_Patients"));
const PatientBirthday = React.lazy(() => import("./components/pages/PatientBirthday"));
const Report_Attendance_View = React.lazy(() => import("./components/pages/Report_Attendance_view"));
const Example = React.lazy(() => import("./components/pages/Example"));
const Profile = React.lazy(() => import("./components/pages/Profile"));
const Messages = React.lazy(() => import("./components/pages/Messages"));
const Settings = React.lazy(() => import("./components/pages/Settings"));
const Chat = React.lazy(() => import("./components/pages/Chat"));
const FollowUpCalls = React.lazy(() => import("./components/pages/FollowUp/FollowUpCalls"));

const existingToken = localStorage.getItem("token");
if (existingToken) {
  axios.defaults.headers.common.Authorization = `Bearer ${existingToken}`;
}

function App() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);

    if (token) {
      axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    } else {
      delete axios.defaults.headers.common.Authorization;
    }

    const interceptorId = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("role_pages");
          delete axios.defaults.headers.common.Authorization;
          setIsLoggedIn(false);

          if (window.location.pathname !== "/") {
            window.location.replace("/");
          }
        }
        return Promise.reject(error);
      }
    );

    return () => axios.interceptors.response.eject(interceptorId);
  }, []);

  // Replace every native browser alert() in the application with the
  // shared toast system. Existing page logic can continue calling alert().
  useEffect(() => {
    const nativeAlert = window.alert;
    window.alert = (message) => {
      window.dispatchEvent(
        new CustomEvent("app-toast", {
          detail: { message: String(message ?? ""), type: "warning" },
        })
      );
    };

    return () => {
      window.alert = nativeAlert;
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
      if (window.innerWidth > 1024) {
        setSidebarOpen(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    if (!isMobile) {
      setSidebarCollapsed(!sidebarCollapsed);
    }
  };

  const toggleMobileSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <Router>
      <SearchHighlightManager />
      <GlobalToast />
      <React.Suspense fallback={<div className="page-loading">Loading...</div>}>
        <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/appointments/prescription-data/bill/:id"
          element={
            <ProtectedRoute>
              <Hospitalbill />
            </ProtectedRoute>
          }
        />
        <Route
          path="/prescription-data/bill/:id"
          element={
            <ProtectedRoute>
              <Prescriptionbill />
            </ProtectedRoute>
          }
        />
        <Route
          path="/pharmacy/sale-pharmacy/add-sale-pharmacy/sale-bill/:invoice_number"
          element={
            <ProtectedRoute>
              <SalesBill />
            </ProtectedRoute>
          }
        />
        <Route
          path="/pharmacy/sale-pharmacy/sale-bill/:invoice_number"
          element={
            <ProtectedRoute>
              <SalePreviewBill />
            </ProtectedRoute>
          }
        />
        {/* IN BILLING TEMPORARILY DISABLED
        <Route
          path="/billing/in-billing/add-billing/op-In-Billing/:billInvoiceNo"
          element={<OpInBilling />}
        />
        */}
        <Route
          path="/billing/out-billing/add-billing/op-bill/:billInvoiceNo"
          element={
            <ProtectedRoute>
              <Opbill />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dischargesummary"
          element={
            <ProtectedRoute>
              <DischargeSummary />
            </ProtectedRoute>
          }
        />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <MainApp
                sidebarCollapsed={sidebarCollapsed}
                sidebarOpen={sidebarOpen}
                isMobile={isMobile}
                toggleSidebar={toggleSidebar}
                toggleMobileSidebar={toggleMobileSidebar}
                closeSidebar={closeSidebar}
              />
            </ProtectedRoute>
          }
        />
        </Routes>
      </React.Suspense>
    </Router>
  );
}

function MainApp({
  sidebarCollapsed,
  sidebarOpen,
  isMobile,
  toggleSidebar,
  toggleMobileSidebar,
  closeSidebar,
}) {
  return (
    <div className="App">
      <Sidebar
        collapsed={isMobile ? false : sidebarCollapsed}
        toggleSidebar={toggleSidebar}
        isOpen={sidebarOpen}
        closeSidebar={closeSidebar}
        isMobile={isMobile}
      />
      <div
        className={`main-content ${
          !isMobile && sidebarCollapsed ? "sidebar-collapsed" : ""
        }`}
        onClick={() => isMobile && sidebarOpen && closeSidebar()}
      >
        <Navbar
          collapsed={sidebarCollapsed}
          toggleMobileSidebar={toggleMobileSidebar}
          isMobile={isMobile}
        />
        <div className="content-wrapper">
          <React.Suspense
            fallback={
              <div className="app-page-loading" role="status">
                Loading page...
              </div>
            }
          >
            <Routes>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/notifications" element={<Notification />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/chat" element={<Chat />} />
            <Route
              path="/follow-up-calls"
              element={<FollowUpCalls stage="courtesy_call" />}
            />
            <Route
              path="/follow-up-calls/follow-up-1"
              element={<FollowUpCalls stage="follow_up_1" />}
            />
            <Route
              path="/follow-up-calls/follow-up-2"
              element={<FollowUpCalls stage="follow_up_2" />}
            />
            <Route
              path="/follow-up-calls/courtesy-call"
              element={<FollowUpCalls stage="courtesy_call" />}
            />
            <Route
              path="/roles"
              element={<Roles toggleSidebar={toggleSidebar} />}
            />
            <Route path="/roles/add-roles" element={<AddRoles />} />
            <Route path="/roles/add-roles/:id" element={<AddRoles />} />
            <Route path="/users" element={<User />} />
            <Route path="/hr-management" element={<HrManagement />} />
            <Route
              path="/hr-management/staff"
              element={<Staff toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/hr-management/staff/add-staff"
              element={<AddStaff />}
            />
            <Route
              path="/hr-management/staff/update-staff/:id"
              element={<UpdateStaff />}
            />
            <Route path="/hr-management/holiday" element={<Holiday />} />
            <Route path="/hr-management/leave" element={<Leave />} />
            <Route path="/hr-management/attendance" element={<Attendance />} />
            <Route path="/hr-management/shift" element={<Shift />} />
            <Route
              path="/hr-management/attendance/attendance-calendar/:staffId"
              element={<AttendanceCalendar />}
            />
            <Route path="/hr-management/department" element={<Department />} />
            <Route
              path="/hr-management/salary-details"
              element={<SalaryDetails />}
            />
            <Route
              path="/hr-management/salary-details/add-salary-details"
              element={<AddSalaryDetails />}
            />
            <Route
              path="/hr-management/salary-details/update-salary-details/:id"
              element={<UpdateSalaryDetails />}
            />
            <Route path="/doctors" element={<Doctors />} />
            <Route path="/fees-management" element={<FeesManagement />} />
            <Route
              path="/fees-management/treatment_charges"
              element={<Treatment />}
            />
            <Route
              path="/fees-management/doctorfee_master"
              element={<Doctorfees />}
            />
            <Route
              path="/fees-management/dynamic_billing"
              element={<DynamicBilling />}
            />

                <Route
              path="/Example"
              element={<Example />}
            />
            <Route
              path="/fees-management/discount_offers"
              element={<DiscountOffer />}
            />
            <Route
              path="/fees-management/bill_customization"
              element={<BillCustomization />}
            />
            <Route path="/patients" element={<Patients />} />
            <Route path="/patients/add-patients" element={<AddPatients />} />
            {/* <Route path="/patients/add-patients" element={<AddPatients />} /> */}
            <Route
              path="/patients/update-patients"
              element={<UpdatePatients />}
            />
            <Route
              path="/patients/view/:patient_id"
              element={<ViewPatient toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/patients/history/:patient_id"
              element={<PatientsHistory />}
            />
            {/* <Route
              path="/patients/yoga-patients"
              element={<Yoga_Patients toggleSidebar={toggleSidebar} />}
            /> */}
            {/* <Route
              path="/patients/homeopathy-patients"
              element={<Homeopathy_Patients toggleSidebar={toggleSidebar} />}
            /> */}
            <Route
              path="/patients/patient-birthday"
              element={<PatientBirthday />}
            />
            {/* IN BILLING TEMPORARILY DISABLED
            <Route
              path="/billing/in-billing"
              element={<InBilling toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/billing/in-billing/add-billing"
              element={<AddInBilling />}
            />
            <Route
              path="/billing/in-billing/update-billing/:id"
              element={<UpdateInBilling />}
            />
            */}
            <Route
              path="/billing/out-billing"
              element={<OutBilling toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/billing/out-billing/add-billing"
              element={<AddOutBilling />}
            />
            <Route
              path="/billing/out-billing/update-billing/:id"
              element={<UpdateOutBilling />}
            />
            <Route path="/expenses" element={<Expenses />} />
            <Route
              path="/hospital-maintenance"
              element={<HospitalMaintainence />}
            />
            <Route path="/hospital-purchases" element={<HospitalPurchase />} />
            <Route
              path="/hospital-purchases/add-hospital-purchase"
              element={<AddHospitalPurchase />}
            />
            <Route
              path="/hospital-purchases/update-hospital-purchase/:id"
              element={<UpdateHospitalPurchase />}
            />
            <Route
              path="/pharmacy/medicine-master"
              element={<MedicineMaster />}
            />
            <Route
              path="/pharmacy/purchase-order"
              element={<PurchaseOrder toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/pharmacy/purchase-pharmacy/add-purchase-order"
              element={<AddPurchaseOrder />}
            />
            <Route
              path="/pharmacy/purchase-pharmacy/update-purchase-order/:id"
              element={<UpdatePurchaseOrder />}
            />
            <Route
              path="/pharmacy/purchase-pharmacy"
              element={<PurchasePharmacy toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/pharmacy/purchase-pharmacy/add-purchase-pharmacy"
              element={<AddPurchasePharmacy />}
            />
            <Route
              path="/pharmacy/purchase-pharmacy/update-purchase-pharmacy/:id"
              element={<UpdatePurchasePharmacy />}
            />
            <Route path="/pharmacy/prescription" element={<Prescription />} />
            <Route
              path="/pharmacy/sale-pharmacy"
              element={<SalePharmacy toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/pharmacy/sale-pharmacy/add-sale-pharmacy"
              element={<AddSalePharmacy />}
            />
            <Route
              path="/pharmacy/sale-pharmacy/update-sale-pharmacy/:id"
              element={<UpdateSalePharmacy />}
            />
            <Route
              path="/pharmacy/sale-pharmacy/add-sale-pharmacy/sale-bill"
              element={<SalesBill />}
            />
            <Route
              path="/pharmacy/stock-management"
              element={<StockPharmacy />}
            />
            <Route path="/pharmacy/supplier" element={<SupplierPharmacy />} />
            <Route path="/pharmacy/reports" element={<ReportPharmacy />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/lab-management" element={<LabManagement />} />
            <Route path="/add-lab-management" element={<AddLabManagement />} />
            <Route
              path="/update-lab-management/:id"
              element={<UpdateLabManagement />}
            />
            <Route
              path="/appointments"
              element={<Appointment toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/appointments/prescription-data/:id"
              element={<PrescriptionData />}
            />
            <Route
              path="/report/report-view-attendance/:staffId"
              element={<Report_Attendance_View />}
            />
            </Routes>
          </React.Suspense>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default App;
